import React from "react";

const TermsAndConditions = () => (
  <div className="legal-page-container">
    <h1>Terms and Conditions</h1>
    <div className="legal-content">
      <p>
        Welcome to Contest Hub! By downloading, installing, or using our app,
        you agree to be bound by these Terms and Conditions. Please read them
        carefully before using the app.
      </p>
      <h2>Quick Navigation</h2>
      <ul>
        <li>Acceptance of Terms</li>
        <li>Services Provided</li>
        <li>User Accounts</li>
        <li>User Conduct</li>
        <li>Disclaimers</li>
        <li>Contact Information</li>
      </ul>
      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using Contest Hub ("the App"), you agree to comply with
        and be bound by these Terms and Conditions ("Terms"). If you do not
        agree to these Terms, please do not use the App.
      </p>
      <p>
        These Terms constitute a legally binding agreement between you ("User"
        or "you") and Contest Hub ("we," "us," or "our"). We reserve the right
        to modify these Terms at any time, and your continued use of the App
        following any changes constitutes acceptance of those changes.
      </p>
      <h2>2. Eligibility</h2>
      <ul>
        <li>Be at least 13 years of age</li>
        <li>Have the legal capacity to enter into a binding agreement</li>
        <li>Not be prohibited from using the App under applicable laws</li>
        <li>
          Comply with all local, state, national, and international laws and
          regulations
        </li>
        <li>
          If you are under 18 years of age, you must have permission from a
          parent or legal guardian to use the App.
        </li>
      </ul>
      <h2>3. Services Provided</h2>
      <h3>3.1 Contest Aggregation</h3>
      <p>
        We aggregate and display information about competitive coding contests
        from various platforms including (but not limited to) Codeforces,
        LeetCode, CodeChef, AtCoder, HackerRank, and others. This information is
        collected from publicly available sources.
      </p>
      <h3>3.2 Notifications and Reminders</h3>
      <p>
        We provide timely notifications and reminders about upcoming contests
        based on your preferences and bookmarked contests.
      </p>
      <h3>3.3 Bookmark Management</h3>
      <p>
        You can bookmark contests, organize them, and access your saved contests
        across devices when signed in with your Google account.
      </p>
      <h3>3.4 Streak Tracking</h3>
      <p>
        We track your contest participation streaks to help you visualize your
        consistency and long-term progress in competitive programming.
      </p>
      <h3>3.5 Data Synchronization</h3>
      <p>
        When you sign in with Google, your bookmarks, preferences, and streak
        data are synchronized across your devices.
      </p>
      <h2>4. User Accounts and Registration</h2>
      <h3>4.1 Google Sign-In</h3>
      <p>
        To access certain features of Contest Hub, you may need to sign in using
        your Google account. By signing in, you authorize us to access certain
        information from your Google account as described in our Privacy Policy.
      </p>
      <h3>4.2 Account Security</h3>
      <ul>
        <li>Maintaining the security of your Google account credentials</li>
        <li>All activities that occur under your account</li>
        <li>
          Notifying us immediately of any unauthorized use of your account
        </li>
      </ul>
      <h3>4.3 Account Termination</h3>
      <ul>
        <li>Signing out and uninstalling the App</li>
        <li>Deleting your account through the App settings</li>
        <li>Contacting us at champ96klabs@gmail.com</li>
      </ul>
      <p>
        We reserve the right to suspend or terminate accounts that violate these
        Terms without prior notice.
      </p>
      <h2>5. User Conduct and Restrictions</h2>
      <ul>
        <li>Use the App for any illegal or unauthorized purpose</li>
        <li>
          Attempt to gain unauthorized access to any part of the App, other
          users' accounts, or connected systems
        </li>
        <li>Interfere with or disrupt the App's servers or networks</li>
        <li>
          Use any automated means (bots, scripts, scrapers) to access the App
          without our express permission
        </li>
        <li>Reverse engineer, decompile, or disassemble any part of the App</li>
        <li>
          Remove, circumvent, or alter any copyright notices, trademarks, or
          proprietary rights notices
        </li>
        <li>Upload or transmit viruses, malware, or any malicious code</li>
        <li>Harass, abuse, or harm other users</li>
        <li>Impersonate any person or entity</li>
        <li>Use the App to spam or send unsolicited communications</li>
        <li>Violate any applicable laws or regulations</li>
      </ul>
      <h2>6. Intellectual Property Rights</h2>
      <h3>6.1 Our Content</h3>
      <p>
        Contest Hub and all its original content, features, functionality,
        designs, logos, and trademarks are owned by us and are protected by
        international copyright, trademark, and other intellectual property
        laws.
      </p>
      <h3>6.2 Third-Party Content</h3>
      <p>
        Contest information, logos, and trademarks of contest platforms
        (Codeforces, LeetCode, CodeChef, etc.) are the property of their
        respective owners. We do not claim ownership of any third-party content
        displayed in the App.
      </p>
      <h3>6.3 User License</h3>
      <p>
        We grant you a limited, non-exclusive, non-transferable, revocable
        license to use the App for personal, non-commercial purposes in
        accordance with these Terms.
      </p>
      <h2>7. Disclaimers and Limitations</h2>
      <p>
        ⚠️ Important Disclaimer: Contest Hub is provided "AS IS" and "AS
        AVAILABLE" without warranties of any kind.
      </p>
      <h3>7.1 No Warranty</h3>
      <ul>
        <li>The App will be uninterrupted, timely, secure, or error-free</li>
        <li>
          The information provided (contest timings, links, details) will always
          be accurate, complete, or up-to-date
        </li>
        <li>Defects will be corrected</li>
        <li>The App or servers are free of viruses or harmful components</li>
        <li>Notifications will always be delivered on time</li>
      </ul>
      <h3>7.2 Contest Information Accuracy</h3>
      <p>
        While we strive to provide accurate and timely contest information, we
        are not responsible for:
      </p>
      <ul>
        <li>Errors or inaccuracies in contest details, timings, or links</li>
        <li>
          Changes made by contest platforms after information is published
        </li>
        <li>Cancelled or rescheduled contests</li>
        <li>Technical issues with external contest platforms</li>
        <li>Missed contests due to notification delays or failures</li>
      </ul>
      <p>
        Always verify contest details on the official platform before
        participating.
      </p>
      <h3>7.3 Third-Party Platforms</h3>
      <p>
        Contest Hub aggregates information from third-party platforms. We are
        not affiliated with, endorsed by, or responsible for the content,
        policies, or practices of these platforms. Your participation in
        contests is governed by the respective platform's terms and conditions.
      </p>
      <h3>7.4 Streak Tracking</h3>
      <p>
        Streak tracking is provided as a motivational tool. We are not
        responsible for:
      </p>
      <ul>
        <li>Loss of streak data due to technical issues</li>
        <li>Inaccuracies in streak calculations</li>
        <li>
          Any consequences of streak tracking on your competitive programming
          activities
        </li>
      </ul>
      <h2>8. Limitation of Liability</h2>
      <ul>
        <li>
          We shall not be liable for any indirect, incidental, special,
          consequential, or punitive damages
        </li>
        <li>
          We shall not be liable for any loss of profits, data, use, goodwill,
          or other intangible losses
        </li>
        <li>
          Our total liability shall not exceed the amount you paid to us (if
          any) in the past twelve months
        </li>
        <li>
          We are not responsible for missed contests, incorrect information, or
          any consequences of using the App
        </li>
      </ul>
      <p>
        Some jurisdictions do not allow limitations on implied warranties or
        liability, so some of these limitations may not apply to you.
      </p>
      <h2>9. Privacy and Data Protection</h2>
      <p>
        Your use of Contest Hub is also governed by our Privacy Policy, which is
        incorporated into these Terms by reference. Please review our Privacy
        Policy at{" "}
        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>{" "}
        to understand how we collect, use, and protect your information.
      </p>
      <ul>
        <li>We use Google Sign-In for authentication</li>
        <li>We use Firebase Analytics to improve the App</li>
        <li>We never sell your personal information</li>
        <li>You can delete your account and data at any time</li>
      </ul>
      <h2>10. Notifications and Communications</h2>
      <ul>
        <li>
          Contest Reminders: Notifications about upcoming contests based on your
          preferences
        </li>
        <li>
          App Updates: Information about new features, updates, or changes to
          the App
        </li>
        <li>
          Important Notices: Service announcements, security alerts, or changes
          to Terms
        </li>
      </ul>
      <p>
        You can manage notification preferences in the App settings or disable
        them entirely through your device settings.
      </p>
      <h2>11. Modifications to the App</h2>
      <ul>
        <li>Modify, suspend, or discontinue any part of the App at any time</li>
        <li>Add or remove features without prior notice</li>
        <li>
          Update the App to improve performance, fix bugs, or add new
          functionality
        </li>
        <li>Change which contest platforms are supported</li>
      </ul>
      <p>
        We are not liable to you or any third party for any modification,
        suspension, or discontinuation of the App.
      </p>
      <h2>12. Changes to Terms and Conditions</h2>
      <ul>
        <li>We will update the "Last Updated" date at the top</li>
        <li>
          For significant changes, we will notify you through the App or via
          email
        </li>
        <li>
          Your continued use of the App after changes constitutes acceptance of
          the new Terms
        </li>
      </ul>
      <p>
        We encourage you to review these Terms periodically to stay informed of
        any updates.
      </p>
      <h2>13. Indemnification</h2>
      <p>
        You agree to indemnify, defend, and hold harmless Contest Hub, its
        developers, and affiliates from any claims, damages, losses,
        liabilities, and expenses (including legal fees) arising from:
      </p>
      <ul>
        <li>Your use or misuse of the App</li>
        <li>Your violation of these Terms</li>
        <li>Your violation of any rights of another person or entity</li>
        <li>Your violation of any applicable laws or regulations</li>
      </ul>
      <h2>14. Governing Law and Dispute Resolution</h2>
      <h3>14.1 Governing Law</h3>
      <p>
        These Terms shall be governed by and construed in accordance with the
        laws of India, without regard to its conflict of law provisions.
      </p>
      <h3>14.2 Dispute Resolution</h3>
      <ul>
        <li>
          Informal Resolution: We encourage you to contact us first at
          champ96klabs@gmail.com to resolve the issue informally
        </li>
        <li>
          Mediation: If informal resolution fails, parties agree to attempt
          mediation before pursuing legal action
        </li>
        <li>
          Jurisdiction: Any legal action shall be brought in the courts of
          Karnataka, India
        </li>
      </ul>
      <h2>15. Severability</h2>
      <p>
        If any provision of these Terms is found to be invalid, illegal, or
        unenforceable, the remaining provisions shall continue in full force and
        effect. The invalid provision shall be modified to the minimum extent
        necessary to make it valid and enforceable.
      </p>
      <h2>16. Entire Agreement</h2>
      <p>
        These Terms, together with our Privacy Policy, constitute the entire
        agreement between you and Contest Hub regarding your use of the App and
        supersede all prior agreements and understandings.
      </p>
      <h2>17. No Waiver</h2>
      <p>
        Our failure to enforce any right or provision of these Terms shall not
        be deemed a waiver of such right or provision. Any waiver must be in
        writing and signed by an authorized representative.
      </p>
      <h2>18. Third-Party Links</h2>
      <p>
        Contest Hub may contain links to third-party websites or services
        (contest platforms). We do not control, endorse, or assume
        responsibility for the content, privacy policies, or practices of any
        third-party sites. You acknowledge and agree that we shall not be liable
        for any damage or loss caused by your use of any third-party content or
        services.
      </p>
      <h2>19. Feedback and Suggestions</h2>
      <p>
        We welcome your feedback and suggestions about Contest Hub. By
        submitting feedback, you grant us the right to use, modify, and
        incorporate your suggestions into the App without any obligation to you
        or compensation.
      </p>
      <h2>✅ Your Acknowledgment</h2>
      <p>
        By using Contest Hub, you acknowledge that you have read, understood,
        and agree to be bound by these Terms and Conditions. You also
        acknowledge that you have read our Privacy Policy and consent to the
        collection and use of your information as described therein.
      </p>
    </div>
  </div>
);

export default TermsAndConditions;
